var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgToperbackgroundimage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1440px",
    height: "600px",
    viewBox: "0 0 1440 600",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 2400,
    height: 600
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "186.370747%",
    y1: "90.539905%",
    x2: "39.3997994%",
    y2: "41.8795733%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BCF80",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BCF80",
    stopOpacity: 0.232599432,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "28.5694%",
    y1: "39.2132007%",
    x2: "102.275204%",
    y2: "57.1431666%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BCF80",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BCF80",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "65.6355932%",
    y1: "56.5967215%",
    x2: "-11.2539725%",
    y2: "42.9039204%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BCF80",
    stopOpacity: 0.014805507,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BCF80",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "54.4116775%",
    x2: "-7.71671119%",
    y2: "26.1033669%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BCF80",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BCF80",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "186.370747%",
    y1: "90.539905%",
    x2: "39.3997994%",
    y2: "41.8795733%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BCF80",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28DAB3",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Solutions",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Solution---Role",
    transform: "translate(0.000000, -75.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-27",
    transform: "translate(-480.000000, 75.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-371.000000, -287.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "url(#linearGradient-3)",
    opacity: 0.400000006,
    points: "889 436.735955 0 73 0 272.264045 889 636"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-5",
    fill: "url(#linearGradient-4)",
    opacity: 0.5,
    points: "909 687.735955 20 324 20 523.264045 909 887"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-3",
    fill: "url(#linearGradient-4)",
    opacity: 0.5,
    points: "2386 526.735955 1497 163 1497 362.264045 2386 726"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy",
    fill: "url(#linearGradient-4)",
    opacity: 0.5,
    points: "2230 516.735955 1341 153 1341 352.264045 2230 716"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-2",
    fill: "url(#linearGradient-5)",
    opacity: 0.5,
    points: "2771 886 2181 623 2181 763 2476 886"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-4",
    fill: "url(#linearGradient-4)",
    opacity: 0.5,
    points: "926 363.735955 37 0 37 199.264045 926 563"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "url(#linearGradient-6)",
    opacity: 0.5,
    points: "2428 802.735955 1539 439 1539 638.264045 2428 1002"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-6",
    fill: "url(#linearGradient-7)",
    opacity: 0.400000006,
    points: "2807 665.735955 1918 302 1918 501.264045 2807 865"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToperbackgroundimage);
export default __webpack_public_path__ + "static/media/toperbackgroundimage.d6bff307f6e87eca5d5d611e06804cfe.svg";
export { ForwardRef as ReactComponent };